import React, { useState, useMemo, useEffect } from 'react';
import {
  Button,
  TextField,
  TableRow,
  TableCell
} from '@material-ui/core';

import RefSelect from '../../RefSelect';
import CurrencyTextField from '@unicef/material-ui-currency-textfield'
import { withStyles } from '@material-ui/styles';
import * as defs from '../PurchaseOrder.module.scss';

const styles = {
  input: {
    '& input[type=number]': {
      textAlign: 'right',
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    }
  },
};

function LineItemEditable({onUpdateLineItem, onCancelEdit, lineItem, costCentres, columnWidths, classes}) {

  const initialState = {
    description: lineItem.description || '',
    cost: lineItem.cost || 0,
    quantity: lineItem.quantity || 1,
    costCentre: lineItem.costCentre || null,
    error: {}
  };

  const [ State, setState ] = useState(initialState);

  const { description, cost, quantity, costCentre, error } = State;

  const clearState = () => {
    setState({ ...initialState });
  };

  function onChange(field, value) {
    setState(prevState => {
      return {
      ...prevState,
      [field]: value,
      error: {}
    }});
  };

  const validationErrors = () => {
    let _error = {};
    if (!costCentre || (costCentre && !costCentre.id))_error.costCentre = 'Required';
    if (!description) _error.description = 'Required';
    return _error;
  }

  function handleSubmit(event) {
    event.preventDefault();    

    const errors = validationErrors();
    if (Object.keys(errors).length > 0) {
      setState(prev => ({...prev, error: errors}))
      return false;
    }

    const newLineItem = {
      description,
      cost: parseFloat(cost),
      quantity: parseFloat(quantity),
      costCentre,
      totalPrice,
    };

    onUpdateLineItem(newLineItem, true);

    clearState();
  }

  function handleCancelEdit() {
    clearState();
    onCancelEdit();
  }

  const totalPrice = useMemo(() => cost * quantity, [cost, quantity]);

  useEffect(() => {
    onUpdateLineItem(State, false);
  }, [State]);

  return (
    <TableRow>
      <TableCell width={columnWidths.description}>
          <TextField
            type="text"
            name="description"
            value={description}
            placeholder="Description"
            InputLabelProps={{ shrink: true }}
            required={true}
            width={50}
            // InputProps={{ disableUnderline: !error.description }}
            {...(error.description && { error: true })}
            fullWidth
            onChange={(event) => onChange('description', event.target.value)}
          />
        </TableCell>
        <TableCell width={columnWidths.costCentre}>
          <RefSelect
            onUpdate={(value) => {onChange('costCentre', value)}}
            options={costCentres}
            error={error.costCentre}
            initialValue={costCentre}
            disableUnderline={true}
          />
        </TableCell>
        <TableCell width={columnWidths.quantity}>
          <TextField
            type="number"
            name="quantity"
            value={quantity}
            placeholder="-"
            InputProps={{ minimum: 1}}
            className={classes.input}
            InputLabelProps={{ shrink: true }}
            fullWidth
            onChange={(event) => onChange('quantity', event.target.value)}
          />
        </TableCell>
        <TableCell width={columnWidths.cost}>
          <CurrencyTextField
            name="cost"
            fullWidth
            required={true}
            currencySymbol="£"
            value={cost}
            // InputProps={{ disableUnderline: true }}
            minimumValue="0"
            decimalCharacter="."
            digitGroupSeparator=","
            onChange={(event, value) => onChange('cost', value)}
          />
        </TableCell>
        <TableCell width={columnWidths.totalPrice}>
          <CurrencyTextField
            currencySymbol="£"
            placeholder='Total'
            decimalCharacter="."
            digitGroupSeparator=","
            InputProps={{ disableUnderline: true, readOnly: true }}
            value={totalPrice}
          />
        </TableCell>
        <TableCell width={columnWidths.buttons}>
          <Button
            className={defs.smallLineItemButton}
            fullWidth
            style={{ height: '100%', display: 'inline-block' }}
            color="primary"
            variant="outlined"
            onClick={handleSubmit}
          >
            Save
          </Button>
          <Button
            className={defs.smallLineItemButton}
            fullWidth
            color="primary"
            variant="outlined"
            style={{ height: '100%', display: 'inline-block' }}
            onClick={handleCancelEdit}
          >Cancel</Button>
        </TableCell>
      </TableRow>
  );

}
export default withStyles(styles)(LineItemEditable);